<template>
  <div class="desc-type-a">
    <div v-if="messages.length === 4 && alarmType === 'N'">
      <b>{{ messages[0] }}</b>
      <br />
      {{ messages[2] }}
    </div>

    <div v-else-if="messages.length === 4">
      <b>{{ messages[0] }}</b>
      {{ messages[1] }}
      <b>{{ messages[2] }}</b>
      {{ messages[3] }}
    </div>

    <div v-else-if="messages.length === 3">
      {{ messages[0] }}
      <b>{{ messages[1] }}</b>
      {{ messages[2] }}
    </div>

    <div v-else>
      {{ messages.join('') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotiContent',
  props: {
    messages: {
      type: Array,
      required: true,
    },
    alarmType: {
      type: String,
      required: true,
    },
  },
};
</script>
